import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../store/auth';
import { OFFSHORE_FLOW_SESSION_KEY } from '../../constants/offshoreLpIntent';

function DashboardGuard({ element }: { element?: React.ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) return;

    // /register é encapsulado por este guard. Quando o usuário acaba de registrar,
    // quem precisa decidir a navegação é o CreateAccountPage (ex: /choose-onboarding).
    // Caso contrário, este guard pode redirecionar indevidamente para /dashboard.
    if (location.pathname === '/register') {
      return;
    }

    const redirectPath = new URLSearchParams(location.search).get('redirect');
    if (redirectPath) {
      navigate(redirectPath, { replace: true });
      return;
    }

    // Login / auth pages: always go to dashboard.
    // OFFSHORE_FLOW_SESSION_KEY is LP→register intent only (handled by CreateAccountPage).
    // Reading it here sent every subsequent login to /choose-onboarding when the key was
    // left as 'choose-onboarding' (CreateAccountPage default) or open/transfer.
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(OFFSHORE_FLOW_SESSION_KEY);
    }

    navigate('/dashboard', { replace: true });
  }, [isAuthenticated, location.pathname, location.search, navigate]);

  if (isLoading && !isAuthenticated) {
    return <></>;
  }

  if (isAuthenticated) {
    return <></>;
  }

  return <>{element}</>;
}

export { DashboardGuard };
